// Kept out of the component files so those modules export components only.

const ORIGIN_KEY = "menuItemsList";

/**
 * History state the list sets when it opens a menu item, so the detail page's
 * Back can step back to the list instead of starting a fresh visit to it.
 *
 * The router types its history state as an open interface that has to be
 * augmented in `@tanstack/history`, which this app does not depend on directly,
 * so the value is passed through untyped.
 */
export function menuItemsOriginState(): never {
  return { [ORIGIN_KEY]: true } as never;
}

/** True when a location's history state says the user came from the list. */
export function cameFromMenuItems(state: unknown): boolean {
  return (state as Record<string, unknown> | null | undefined)?.[ORIGIN_KEY] === true;
}
